import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './styles/style.scss'
import './styles/erp.scss'
import './theme/theme.scss'
import ThemeProvider from './theme/ThemeProvider'
import LanguageProvider from './localization/LanguageProvider'
import App from './App'
import { Provider } from 'react-redux'
import { store } from 'store/index'
import "./i18n";
const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <LanguageProvider><ThemeProvider><App /></ThemeProvider></LanguageProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
)
